import { motion } from "framer-motion";
import React from "react";
import theme from "../theme/theme1";

const events = [
  {
    date: "NOV 07",
    type: "Educational Seminar",
    title: "Understanding Consumer Behavior: A Workshop on Market Trends and Analysis",
    time: "10:00 AM PT",
    videoUrl: "https://www.youtube.com/embed/cBiSOycMdTs",
  },
  {
    date: "NOV 07",
    type: "Therapy & Wellbeing",
    title: "Pawsitive Pet Therapy: Enhancing Student Wellbeing Through Animal-Assisted Therapy 🐾",
    time: "11:30 AM PT",
    videoUrl: "https://www.youtube.com/embed/msEZrq2Cpms",
  },
  {
    date: "NOV 07",
    type: "Research Talk",
    title: "Exploring Comparative Research Methods in Education: Insights from Tanya Marie Luhrmann",
    time: "12:00 PM PT",
    videoUrl: "https://www.youtube.com/embed/tHfpQq-gFYA",
  },
  {
    date: "NOV 07",
    type: "Academic Seminar",
    title: "Cognitive Neuroscience in Education: A Seminar by Dr. Cristina Zavaleta",
    time: "12:00 PM PT",
    videoUrl: "https://www.youtube.com/embed/ZRARmO8x510",
  },
];

const EventCard = ({ event }) => (
  <motion.div
    className="relative shadow-lg hover:shadow-2xl transition-all transform hover:scale-105"
    style={{
      backgroundColor: theme.Events.cardBackground,
      boxShadow: theme.Events.cardShadow,
      padding: "16px",
      borderRadius: "16px",
      overflow: "hidden",
      transition: "transform 0.3s ease, box-shadow 0.3s ease",
    }}
    whileHover={{ scale: 1.05 }}
  >
    {/* Embedded Video */}
    <iframe
      className="w-full h-48 sm:h-56 lg:h-64 xl:h-72 object-cover rounded-t-lg"
      src={event.videoUrl}
      frameBorder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title={event.title}
    ></iframe>

    {/* Event Date Overlay */}
    <div
      className="absolute top-4 left-4 px-4 py-1 text-sm font-semibold rounded-full"
      style={{
        backgroundColor: theme.Events.overlayBackground,
        color: theme.Events.overlayTextColor,
      }}
    >
      {event.date}
    </div>

    {/* Event Details */}
    <div className="p-4 space-y-2" style={{ fontFamily: theme.Events.titleFontFamily }}>
      <h3
        className="text-lg sm:text-xl font-semibold truncate"
        style={{ color: theme.Events.eventTitleColor }}
      >
        {event.title}
      </h3>
      <p className="text-sm sm:text-base" style={{ color: theme.Events.eventTimeColor }}>
        {event.time}
      </p>
      <span
        className="text-xs sm:text-sm font-bold uppercase tracking-wide"
        style={{ color: theme.Events.eventTypeColor }}
      >
        {event.type}
      </span>
    </div>
  </motion.div>
);

const EventGrid = () => (
  <div
    className="py-12 px-4 bg-gradient-to-r from-[#b3a369] to-[#f8f4e8] font-sans relative overflow-hidden"
    style={{ fontFamily: theme.fontFamily }}
  >
    <section
      className="py-16 px-6 lg:px-12"

    >


      {/* Soft Lighting Effects */}
      <div className="absolute inset-0 bg-radial-gradient-light"></div>

      {/* Parallax Scrolling Background */}
      <div className="absolute inset-0 bg-parallax-light"></div>


      {/* Section Heading */}
      <div className="text-center mb-10">
        <motion.div
          className="text-center mb-12"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <h2 className="text-5xl font-extrabold text-[#13294b] tracking-wide">
            Past School Events

          </h2>
          <h3 className="text-2xl font-bold text-[#13294b] mt-4 tracking-wide">
            Explore the highlights from our recent educational and academic events.
          </h3>
        </motion.div>

      </div>

      {/* Event Cards Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 gap-8">
        {events.map((event, index) => (
          <EventCard key={index} event={event} />
        ))}
      </div>
    </section>
  </div>


);

export default EventGrid;
